import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f7de37e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block pt-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-4 mt-0 text-center fw-bold text-primary" }, " Changer de produit ", -1))
const _hoisted_3 = { class: "p-5 m-5 pt-1 pb-1 mt-0 mb-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "fw-bold text-dark"
}
const _hoisted_6 = {
  key: 1,
  class: "fw-bold text-dark"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h4 ms-4 fw-semibold text-dark" }, " 🛒 Dans mon panier ", -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "fw-bold w-100 small-text text-break",
  style: {"color":"black"}
}
const _hoisted_10 = {
  key: 0,
  class: "d-inline small-text"
}
const _hoisted_11 = {
  key: 1,
  class: "small my-auto"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h4 ms-4 mt-3 fw-semibold text-dark" }, " 👇 Disponibles en magasin ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "open-modal",
  expand: "block"
}, null, -1))

import {
  IonIcon,
  IonModal,
  IonSpinner,
} from '@ionic/vue';
import { close } from 'ionicons/icons';
import { ref, watch } from 'vue';
import useCurrentShoppingSessionStore from '@/stores/shopping/currentShoppingSessionStore';
import { Cart, CartProduct, Product, Store } from '@/services/flyingBlue';
import ProductCartChange from './ProductCartChange.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductModalChange',
  props: {
  isOpen: Boolean,
  searchParams: {
    type: String,
    required: false,
    default: '',
  },
  currentProduct: {
    type: Object,
    required: true,
  },
},
  emits: ["closeModal", "productTap"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const store = useCurrentShoppingSessionStore();
const currentStore = store.$state.shopInfos.selectedStore as Store;
const productCarts = ref([] as CartProduct[]);

const currentShoppingSessionStore = useCurrentShoppingSessionStore();
const currentCart = currentShoppingSessionStore.$state.cartsInfos.selectedCart as Cart;


const isLoading = ref(false);
isLoading.value = true;
store.getSimilarProducts(props.currentProduct as CartProduct, currentStore)
  .then((results : any) => {
    const products = results.data as Product[];
    productCarts.value.push(...products.map((p) => ({
      productId: 0,
      id: p.id,
      name: p.name,
      price: p.price,
      product: p,
      qty: 1,
      other_product: false,
    })));
    isLoading.value = false;
  });
const fetchProducts = async () => {
  productCarts.value = [];
  isLoading.value = true;
  store.getSimilarProducts(props.currentProduct as CartProduct, currentStore)
    .then((results : any) => {
      const products = results.data as Product[];
      productCarts.value.push(...products.map((p) => ({
        productId: 0,
        id: p.id,
        name: p.name,
        price: p.price,
        product: p,
        qty: 1,
        other_product: false,
      })));
      isLoading.value = false;
    });
};

watch(() => props.currentProduct, () => {
  fetchProducts();
});

const changeProduct = (cartProduct: CartProduct) => {
  currentShoppingSessionStore.switchProduct(cartProduct.product, props.currentProduct.id);
  currentShoppingSessionStore.updateSelectedCart(currentCart);
  emit('closeModal');
};

const showProductDetail = (event : any) => {
  emit('productTap', event);
};


return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_nutriscore_display = _resolveComponent("nutriscore-display")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonModal), {
      ref: "modal",
      trigger: "open-modal",
      "is-open": __props.isOpen,
      "initial-breakpoint": "1",
      breakpoints: [0, 1],
      onDidDismiss: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('closeModal')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ion_content, { color: "light" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, {
                color: "light",
                class: "pt-0 m-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "icon-only",
                            icon: _unref(close)
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      alt: "",
                      class: "img-fluid",
                      src: __props.currentProduct?.product?.default_image
                    }, null, 8, _hoisted_4)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "justify-content-center mb-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "tertiary",
                    fill: "solid",
                    shape: "round",
                    class: "m-1"
                  }, {
                    default: _withCtx(() => [
                      (__props.currentProduct.product?.weight > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Quantité : " + _toDisplayString(__props.currentProduct?.product.weight) + " kg ", 1))
                        : _createCommentVNode("", true),
                      (__props.currentProduct.product?.weight == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Quantité : " + _toDisplayString(__props.currentProduct?.product.packaging_label), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "mt-4" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              (__props.currentProduct.product)
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 0,
                    class: "ion-padding"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "4",
                        class: "px-3 my-auto"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            alt: "",
                            class: "img-fluid",
                            src: __props.currentProduct.product?.default_image,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (showProductDetail(__props.currentProduct.product.id)))
                          }, null, 8, _hoisted_8)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(__props.currentProduct.product?.name), 1),
                          _createVNode(_component_nutriscore_display, {
                            class: "d-inline my-2 me-2",
                            rating: __props.currentProduct.product.nutriscore_grade ?? 'a'
                          }, null, 8, ["rating"]),
                          (__props.currentProduct.product?.weight > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(Number(__props.currentProduct.product?.weight)?.toFixed(2)) + "kg ", 1))
                            : _createCommentVNode("", true),
                          (__props.currentProduct.product?.weight == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(__props.currentProduct.product?.packaging_label), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _hoisted_12,
                  (!isLoading.value)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(productCarts.value, (p, index) => {
                        return (_openBlock(), _createBlock(ProductCartChange, {
                          key: `products-${index}`,
                          "cart-product": p,
                          onSwitchProduct: _cache[2] || (_cache[2] = ($event: any) => (changeProduct($event))),
                          onProductTap: _cache[3] || (_cache[3] = ($event: any) => (showProductDetail($event)))
                        }, null, 8, ["cart-product"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_ion_row, {
                        key: 1,
                        class: "mt-4 ion-justify-content-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { class: "mt-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonSpinner), { name: "crescent" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _hoisted_13
  ], 64))
}
}

})